import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Header from './header';
import WelcomeSection from './welcome';
import AboutUs from './aboutus';
import { SessionExpireDialog } from '../../components';

const styles = {
  div: {
    display: 'flex',
    flexDirection: 'row wrap',
    padding: 0,
    width: '100%',
  },
  howItWorkSectionHeading: {
    textAlign: 'center',
    margin: '0 20%',
  },
  LandingPageWrapper: {
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
  },
};

class LandingPage extends Component {
  state = {
    open: false,
    timestamp: 0,
    expiredAt: 0,
  };

  componentDidMount = () => {
    const isExpired = localStorage.getItem('isExpired');
    if (isExpired) {
      localStorage.setItem('isExpired', false);
      // this.setState({
      //   open: true,
      //   timestamp: new Date().getTime(),
      //   expiredAt: new Date().getTime(),
      // });
    }
    // setInterval(()=>{
    //   this.setState({timestamp: new Date().getTime()})
    // }, 1000);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      domain, clientID, redirectURI, authServer, classes,
    } = this.props;
    return (
      <div className={classes.LandingPageWrapper}>
        <SessionExpireDialog
          open={this.state.open}
          // timestamp={this.state.timestamp}
          // expiredAt={this.state.expiredAt}
          handleClose={this.handleClose}
        />
        <Header
          {...{
            domain,
            clientID,
            redirectURI,
            authServer,
          }}
        />
        <WelcomeSection />
        <AboutUs />
      </div>
    );
  }
}

export default withStyles(styles)(LandingPage);
